export default __webpack_public_path__ + "static/media/folder_content_2.11c74824.png";